var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _circle, _path7, _path8, _path9, _path0, _path1, _path10, _rect4, _rect5, _rect6, _circle2, _path11, _circle3, _circle4, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect7, _rect8, _rect9, _ellipse, _path20, _ellipse2, _ellipse3, _path21, _g2, _path22, _path23, _path24, _path25, _path26, _path27, _rect0, _rect1, _rect10, _circle5, _path28, _circle6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.898,
    height: 453.442,
    viewBox: "0 0 799.898 453.442",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-401.995 -223.682)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(720.229 491.093)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M588.619,624.765H571.034V489.426h14.3a2.62,2.62,0,0,1,2.62,2.607Z",
    transform: "translate(-381.608 -440.886)",
    fill: "#ccc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M498.7,641.159H309.863V544.774H498.7Z",
    transform: "translate(-307.631 -456.563)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M424.412,640.942H310.363V545.274H498.484v21.6A74.156,74.156,0,0,1,424.412,640.942Z",
    transform: "translate(-307.773 -456.705)",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512.061,493.27h0a2.623,2.623,0,0,0-.219.566l-6.512,25.1-7.063,13.376h-187.4V528.98l10.67-10.045,12.447-23.807a10.624,10.624,0,0,1,2.135-2.815h0a10.625,10.625,0,0,1,7.281-2.887h166.35a2.62,2.62,0,0,1,2.317,3.844Z",
    transform: "translate(-307.914 -440.886)",
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M498.7,641.159H309.863V544.774H498.7Zm-187.4-1.434H497.267V546.208H311.3Z",
    transform: "translate(-307.631 -456.563)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M232.36,292.9l-3.479,12.826H45.084l5.939-10.675Z",
    transform: "translate(-31.465 -227.674)",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.103,
    height: 1.666,
    transform: "translate(9.195 138.718)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30.103,
    height: 1.666,
    transform: "translate(9.195 144.548)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 30.103,
    height: 1.666,
    transform: "translate(9.195 150.379)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.828,
    cy: 10.828,
    r: 10.828,
    transform: "translate(10.028 98.505)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M497.787,492.479h-9.2V421.7h7.479a1.37,1.37,0,0,1,1.37,1.363Z",
    transform: "translate(-358.256 -421.703)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M450.764,501.052H352.01v-50.4h98.754Z",
    transform: "translate(-319.569 -429.902)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M411.914,500.939H352.272v-50.03H450.65V462.2a38.78,38.78,0,0,1-38.736,38.736Z",
    transform: "translate(-319.644 -429.976)",
    fill: "#f2f2f2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M457.751,423.714h0a1.37,1.37,0,0,0-.115.3l-3.405,13.126-3.694,7h-98v-1.742l5.58-5.253,6.509-12.45a5.557,5.557,0,0,1,1.116-1.472h0a5.556,5.556,0,0,1,3.807-1.51h86.993a1.37,1.37,0,0,1,1.212,2.01Z",
    transform: "translate(-319.718 -421.703)",
    fill: "#f2f2f2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M450.764,501.052H352.01v-50.4h98.754Zm-98-.75h97.254V451.4H352.76Z",
    transform: "translate(-319.569 -429.902)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M177.59,214.071l-1.819,6.707H79.653l3.106-5.583Z",
    transform: "translate(-41.257 -205.346)",
    fill: "#ccc"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 15.742,
    height: 0.871,
    transform: "translate(36.083 47.158)",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 15.742,
    height: 0.871,
    transform: "translate(36.083 50.207)",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 15.742,
    height: 0.871,
    transform: "translate(36.083 53.256)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.662,
    cy: 5.662,
    r: 5.662,
    transform: "translate(36.518 26.129)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M332.248,449.843a24.9,24.9,0,0,0-25.491,24.3c-.33,13.748,9.459,42.672,23.617,53.751,4.08-23.989,24.422-39.8,26.17-52.555C358.411,461.709,346,450.173,332.248,449.843Z",
    transform: "translate(-306.749 -429.672)",
    fill: "#d1d3d4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.121,
    cy: 8.121,
    r: 8.121,
    transform: "translate(14.821 34.622)",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.319,
    cy: 5.319,
    r: 5.319,
    transform: "translate(14.561 99.645)",
    fill: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M344.571,472.13a8.121,8.121,0,1,1-7.1,14.6,8.12,8.12,0,0,0,4.6-15.355A8.121,8.121,0,0,1,344.571,472.13Z",
    transform: "translate(-315.45 -435.774)",
    fill: "#231f20",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.446,475.494c-1.748,12.751-22.089,28.567-26.17,52.555a34.453,34.453,0,0,1-3.748-3.441c4.967-22.649,24.011-37.831,25.7-50.15,1.511-11.026-6.332-20.683-16.665-24.141C355.874,452.278,366.158,463.008,364.446,475.494Z",
    transform: "translate(-314.618 -429.808)",
    fill: "#231f20",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(954.546 314.702)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M534.851,723.473H342.088c-.339,0-.614-.553-.614-1.236s.275-1.236.614-1.236H534.851c.339,0,.614.553.614,1.236S535.191,723.473,534.851,723.473Z",
    transform: "translate(-341.474 -364.097)",
    fill: "#e6e6e6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.426 10.111)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.04 39.128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.548,142.9a14.971,14.971,0,0,1-5.7,4.179l-6.322,7.119-17.907,21.623-12.1,7.318-5.619-9.671,26.516-25.831,7.39-7.518a14.961,14.961,0,0,1,3.322-6.244c3.914-4.521,9.421-6.168,12.3-3.676s2.036,8.178-1.88,12.7Z",
    transform: "translate(-224.315 -129.034)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.757,166.517l11.645-19.38,49.544,21.287,27.08-22.126,11.127,9.585c.384.331-27.308,38.685-29.274,38.64s-70.122-28.007-70.122-28.007Z",
    transform: "translate(-215.756 -131.17)",
    fill: "#f15923"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 17.219,
    height: 33.425,
    transform: "translate(29.085 40.851)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.328,236.869,223.8,233.83s-17.22,39.5-4.052,64.824l9.117,52.67-3.607,86.69h18.862l29.31-139.36Z",
    transform: "translate(-190.597 -102.879)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.79,287.792l16.2,14.106-8.1,138.149H251.662Z",
    transform: "translate(-195.162 -109.559)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.527,
    cy: 21.527,
    r: 21.527,
    transform: "translate(15.935 4.368)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.859,443.381,248.1,446.9l4.18,15.951s18.056,6.795,9.356,14.178-40.841,3.566-43.381-1.73S225.859,443.381,225.859,443.381Z",
    transform: "translate(-190.976 -128.82)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.668,443.38l22.238,3.513,4.18,15.951s18.056,6.795,9.356,14.178-40.841,3.566-43.381-1.73,7.609-31.913,7.609-31.913Z",
    transform: "translate(-193.552 -128.819)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.73,231.107a14.969,14.969,0,0,1-6.888-1.593l-9.52-.144-28.069.544-13.441-4.39,3.661-10.566,36.879,3.233,10.519.692a14.96,14.96,0,0,1,6.9-1.558c5.981.014,10.82,3.113,10.812,6.919s-4.866,6.88-10.85,6.864Z",
    transform: "translate(-195.181 -100.543)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.829,145.4H216.518l-7.05,21.271,13.674,56.214,41.528,3.039-2.532-22.789h0a23.08,23.08,0,0,0-.991-25.671Z",
    transform: "translate(-189.939 -91.933)",
    fill: "#f15923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.715,155.262,241,151.436l16.2,51.43,34.438,6.077V223.63c0,.508-47.133,4.558-48.382,3.039s-24.545-71.408-24.545-71.408Z",
    transform: "translate(-191.082 -92.679)",
    fill: "#f15923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.39,97.79c2.645,4.29.206,9.941-3.051,13.787s-7.459,7.221-8.913,12.046c-1.3,4.326-.118,8.991,1.416,13.243s3.441,8.488,3.6,13-1.981,9.5-6.233,11.027c-4.365,1.565-9.526-.894-13.73,1.062-5.476,2.547-6.717,11.366-12.687,12.28-3.674.563-7.079-2.623-8.106-6.2s-.29-7.385.453-11.027l6.1-29.936,5.077-24.909c1.01-4.957,2.209-10.261,5.935-13.683,4.553-4.182,11.415-4.282,17.592-4.031,5.675.23,11.582.619,16.52,3.421s8.57,8.758,6.858,14.173a8.542,8.542,0,0,0-10.276-4.606",
    transform: "translate(-187.179 -84.376)",
    fill: "#090814"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M440,386.844h9.8V311.4h-7.972a1.461,1.461,0,0,0-1.461,1.453Z",
    transform: "translate(-306.796 -254.088)",
    fill: "#ccc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M447.067,329h105.26v53.726H447.067Z",
    transform: "translate(-304.979 -249.567)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M447.226,341.193V329.156h104.86v53.326H488.514A41.335,41.335,0,0,1,447.226,341.193Z",
    transform: "translate(-304.937 -249.525)",
    fill: "#f2f2f2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M441.3,313.547h0a1.463,1.463,0,0,1,.122.316l3.63,13.991,3.937,7.456h104.46v-1.857l-5.947-5.6-6.938-13.271a5.92,5.92,0,0,0-1.19-1.569h0a5.922,5.922,0,0,0-4.058-1.609H442.594a1.461,1.461,0,0,0-1.291,2.143Z",
    transform: "translate(-306.504 -254.087)",
    fill: "#f2f2f2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M447.067,329h105.26v53.726H447.067Zm104.461,52.927H447.866V329.8H551.528Z",
    transform: "translate(-304.979 -249.567)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M162.045,99l1.939,7.15h102.45l-3.311-5.95Z",
    transform: "translate(-25.434 -32.382)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M447.067,329h105.26v53.726H447.067Zm104.461,52.927H447.866V329.8H551.528Z",
    transform: "translate(-304.979 -249.567)",
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 16.779,
    height: 0.929,
    transform: "translate(226.688 107.583)",
    fill: "#f15923"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 16.779,
    height: 0.929,
    transform: "translate(226.688 110.832)",
    fill: "#f15923"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 16.779,
    height: 0.929,
    transform: "translate(226.688 114.082)",
    fill: "#f15923"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.036,
    cy: 6.036,
    rx: 6.036,
    ry: 6.036,
    transform: "translate(230.931 85.166)",
    fill: "#f15923"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M489.193,265.812a26.757,26.757,0,0,1,27.391,26.107c.355,14.773-10.164,45.854-25.378,57.759-4.385-25.778-26.243-42.773-28.121-56.474C461.079,278.563,474.42,266.167,489.193,265.812Z",
    transform: "translate(-300.915 -265.804)",
    fill: "#d1d3d4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.726,
    cy: 8.726,
    rx: 8.726,
    ry: 8.726,
    transform: "translate(182.301 15.535)",
    fill: "#f15923"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.716,
    cy: 5.716,
    rx: 5.716,
    ry: 5.716,
    transform: "translate(188.602 85.407)",
    fill: "#f15923"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M481.722,279.811a8.726,8.726,0,0,0,7.634,15.694,8.725,8.725,0,0,1-4.947-16.5,8.726,8.726,0,0,0-2.688.806Z",
    transform: "translate(-297.336 -262.413)",
    fill: "#231f20",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.057,293.153c1.878,13.7,23.736,30.7,28.121,56.474a37.007,37.007,0,0,0,4.028-3.7c-5.337-24.338-25.8-40.651-27.616-53.89-1.624-11.848,6.8-22.226,17.908-25.942C472.268,268.207,461.218,279.737,463.057,293.153Z",
    transform: "translate(-300.922 -265.728)",
    fill: "#231f20",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(401.995 223.682)"
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M534.851,723.473H342.088c-.339,0-.614-.553-.614-1.236s.275-1.236.614-1.236H534.851c.339,0,.614.553.614,1.236S535.191,723.473,534.851,723.473Z",
    transform: "translate(-253.308 -273.379)",
    fill: "#e6e6e6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(132.749 94.151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.553,138.431c-4.418-4.5-10.321-5.861-13.18-3.049s-1.6,8.735,2.822,13.232a15.775,15.775,0,0,0,6.275,4.014l18.956,18.816,8.642-9.083L161.46,144.779a15.776,15.776,0,0,0-3.908-6.345Z",
    transform: "translate(-142.843 -66.202)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.183,125.973l-19.878,44.1L107.562,152.89,96.2,158.919s25.946,43.382,43.717,38.444,49.317-49.717,43.633-63.538-24.369-7.853-24.369-7.853Z",
    transform: "translate(-83.838 -69.274)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.84,360.131H115.345l-6.9-55.906h21.393Z",
    transform: "translate(-45.778 -9.528)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.626,350.005h0a12.436,12.436,0,0,0-.69,4.1h0a4.92,4.92,0,0,0,4.918,4.92h44.889a3.356,3.356,0,0,0,3.356-3.356V353.8s2.222-5.617-2.351-12.543c0,0-5.682,5.421-14.172-3.07l-2.5-4.536L121.949,346.9,111.9,348.14c-2.2.27-4.146-.042-5.277,1.864h0Z",
    transform: "translate(-72.225 0.269)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.313,134.534l-.293-19.55,12.056-7.515L123.185,123.5Z",
    transform: "translate(-25.22 -75.004)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.441,
    cy: 21.441,
    r: 21.441,
    transform: "translate(51.614 3.181)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.663,232.868l19.973,135.914H144.7L141.363,291.2,139.609,250.4l5.089-19.417a86.725,86.725,0,0,0,4.273-9.548c2.2-5.9,3.942-12.982,1.362-16.342-.95-1.237-3.42-2.15-6.776-2.835a70.133,70.133,0,0,0-7.015-1c-14.819-1.466-35.9-.55-35.9-.55l-.536,17.684-.3,9.875Z",
    transform: "translate(-55.849 -44.065)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.595,354.994,104.254,357.1,89.3,302.79l21.166-3.11Z",
    transform: "translate(-9.005 -11.038)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.815,351.612h0a12.445,12.445,0,0,0-.086,4.157h0a4.92,4.92,0,0,0,5.583,4.151l44.41-6.532a3.356,3.356,0,0,0,2.833-3.809l-.272-1.849s1.38-5.877-4.15-12.064c0,0-4.833,6.19-14.468-.975l-3.137-4.123-16,15.75L91.765,349c-2.135.587-4.108.562-4.95,2.61h0Z",
    transform: "translate(-26.402 -0.759)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.569,211.045l2.739,23.592,14.94,49.716L130.842,366.2l24.789-3.643L133.383,246.181l2.2-19.956s.717-1.983,1.54-4.888c1.632-5.745,3.68-15.1,1.427-19.873a5.579,5.579,0,0,0-1.158-1.667c-.886-.86-2.686-1.381-5.1-1.658-10.083-1.14-30.849,2.12-40.088,3.72l-3.638,9.184Z",
    transform: "translate(-45.069 -44.908)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.936,116.4l-24.357,11.692S94.76,204.574,94.76,208.471s-7.307,6.333-2.923,10.718-8.16,8.1-1.4,11.6,48.927,22.658,53.613,20.929c12.932-4.764-.548-22.271-.548-22.271s9.717-7.827,8.256-11.721,8.769-78.43,8.769-78.43Z",
    transform: "translate(-49.728 -72.035)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.954,112.871,123.2,118.39s-2.758-9.928-7.167-12.134-4.964-5.519-4.964-5.519-5.519,7.167-9.377,5.519-5.519-2.758-1.1-9.377,3.309-3.309,3.309-3.309,3.861-5.519,3.309-3.861,3.309-4.412,3.309-2.758,2.758-3.309,2.758-1.655,11.583-3.861,9.928-1.655,9.929-4.414,15.441,4.408,13.163,7.193,10.442,12.7-1.619,20.4-1.619,20.4h-7.6s-7.837-14.892-13.9-8.273Z",
    transform: "translate(-51.589 -83.112)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.793 60.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.835,167.141c-6.045-1.786-11.866-.115-13,3.733s2.843,8.412,8.888,10.2a15.775,15.775,0,0,0,7.436.465l25.708,7.243,3.142-12.137-25.678-5.852a15.776,15.776,0,0,0-6.5-3.65Z",
    transform: "translate(-131.639 -116.004)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.165,136.718l4.03,48.2-36.093.388-7,10.786s43.747,25.33,56.883,12.388,18.98-67.408,7.3-76.732-25.116,4.965-25.116,4.965Z",
    transform: "translate(-78.498 -128.593)",
    fill: "#e6e6e6"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M801.111,461.45h-7.782V401.556h6.329a1.16,1.16,0,0,1,1.16,1.154Z",
    transform: "translate(-639.805 -253.525)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M797.7,461H714.13V418.34H797.7Z",
    transform: "translate(-643.449 -252.752)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M764.754,460.83H714.282V418.492h83.253v9.557a32.818,32.818,0,0,1-32.781,32.781Z",
    transform: "translate(-643.442 -252.745)",
    fill: "#f15923"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M803.474,403.258h0a1.16,1.16,0,0,0-.1.251l-2.882,11.108-3.126,5.92H714.433v-1.474l4.722-4.445,5.508-10.536a4.7,4.7,0,0,1,.945-1.246h0a4.7,4.7,0,0,1,3.222-1.278h73.618a1.16,1.16,0,0,1,1.025,1.7Z",
    transform: "translate(-643.435 -253.525)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M797.7,461H714.13V418.34H797.7Zm-82.936-.634h82.3V418.975h-82.3Z",
    transform: "translate(-643.449 -252.752)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M521.161,188.809l-1.539,5.677H438.283l2.628-4.725Z",
    transform: "translate(-362.562 -33.395)",
    fill: "#f15923"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 13.322,
    height: 0.737,
    transform: "translate(73.763 187.938)",
    fill: "#fff"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 13.322,
    height: 0.737,
    transform: "translate(73.763 190.518)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 13.322,
    height: 0.737,
    transform: "translate(73.763 193.099)",
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.792,
    cy: 4.792,
    r: 4.792,
    transform: "translate(74.131 170.144)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M668.282,264.345a39.218,39.218,0,0,0-17.592,52.6c9.667,19.383,44.6,52.44,72.469,57.434-11.989-36.4,4.681-73.4-2.278-92.44C713.445,261.594,687.665,254.678,668.282,264.345Z",
    transform: "translate(-646.559 -260.037)",
    fill: "#f15923"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.79,
    cy: 12.79,
    r: 12.79,
    transform: "translate(21.998 24.825)",
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.377,
    cy: 8.377,
    r: 8.377,
    transform: "translate(67.977 118.114)",
    fill: "#f15923"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M683.721,283.145a12.79,12.79,0,1,1,.866,25.565,12.788,12.788,0,0,0-4.9-24.767A12.792,12.792,0,0,1,683.721,283.145Z",
    transform: "translate(-645.034 -258.974)",
    fill: "#231f20",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.767,281.944c6.958,19.038-9.711,56.039,2.278,92.44a54.255,54.255,0,0,1-7.752-2.029c-9.768-35.189,5.563-70.351-1.16-88.745-6.017-16.463-24.049-24.131-40.982-21.334C690.734,255.938,712.954,263.3,719.767,281.944Z",
    transform: "translate(-645.381 -260.037)",
    fill: "#231f20",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.cd14a96ae79d90620b112d075dfb433f.svg";
export { ForwardRef as ReactComponent };